import React from "react";
import Layout from "../../components/Layout";
import '../../assets/styles/global.css';
import EvaluationNavigation from "../../components/EvaluationNavigation";
import { useAuth } from "../../auth/AuthContext";

const EmpEvaluationPage=()=> {
  const {userInfo} = useAuth();
  const hierarchyRole = userInfo?.hierarchyRole
  return (
    <Layout>
      <div className="d-flex flex-column">
        { (hierarchyRole ==='none' || !hierarchyRole)?
        <div className="alert alert-warning text-center">
        <strong>لايوجد لديك رئيس/مرؤوس</strong>
      </div>
        :
        <EvaluationNavigation/>
        }
      </div>
    </Layout>
  );
}

export default EmpEvaluationPage;
